import { useEffect, useState, useRef, Fragment } from "react";
import Switch from "@mui/material/Switch";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { FiPlus } from "react-icons/fi";
import { MdEdit } from "react-icons/md";
import { MdDeleteOutline } from "react-icons/md";
import { IoMdCloseCircle } from "react-icons/io";
import Pruef_PlanActions from "../../../Actions/Pruef_PlanActions";
import pruef_PlanConstants from "../../../Constants/Pruef_PlanConstants";
import { useLanguageContext } from "../../../Context/LanguageContext";
import commonUtils from "../../../helpers/commonUtils";
import { useGlobalSpinnerActionsContext } from "../../../Context/GlobalSpinnerContext";
import pruefPlanStores from "../../../Stores/PruefPlanStore";
import { CheckBox } from "./CheckBox";
import { useSelectedConfigContext } from "../../../Context/GlobalContext";
import AddBlockQuestions from "./AddBlockQuestions";
import equipmentGroupStore from "../../../Stores/EquipmentGroupStore";
import EquipmentGroupContants from "../../../Constants/EquipmentGroupConstants";
import EquipmentGroupActions from "../../../Actions/EquipmentGroupActions";
import { toast } from "react-toastify";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ConfirmationPopUp from "../../MessageBox/ConfirmationPopUp";

function scheduleObjIntial() {
  return {
    fixedSchedule: true,
    toleranceCheck: 0,
    generateInspection: false,
    deleteInspection: "",
    deleteInspectionPhoto: "",
  };
}
function pruefplanIntial() {
  return {
    checklistTitle: "",
    checklistDesc: "",
    ChecklistNr: "",
    turnusanzahl: "",
    turnuszyklus: "",
    kurzbezeichnung: "",
    kostPruefGroupsId: "",
  };
}
const CreateDigitalChecklist = (props) => {
  const {
    isKostenstelleFlag,
    equipmentGroupName,
    pruefPlanId,
    egId,
    closePrufePlanEditPopUpCallback,
    viewModeOnly,
    isWizard,
    checkListDetails,
    addChecklistFlag,
    getCheckListDetails,
    isChecklistFromTemplate,
    setIsCreateTemplateModalOpen,
    setChecklistDataForTemplate,
  } = props;
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const { localization } = useLanguageContext();
  const selectedConfig = useSelectedConfigContext();
  const [equipmentGroupId, setEquipmentGroupId] = useState(0);
  const [kostPruefGroupsList, setKostPruefGroupsList] = useState([]);
  const [egName, setegName] = useState("");
  const [currentPruefPlan, setCurrentPruefPlan] = useState();
  const [purefPlanData, setpurefPlanData] = useState(pruefplanIntial);
  const [daysCheck, setDaysCheck] = useState(weekDays);
  const [currentPruefPlanId, setCurrentPruefPlanId] = useState(0);
  const [numberOfSchedules, setNumberOfSchedules] = useState("Single");
  const [frequencySchedules, setFrequencySchedules] = useState("");
  const [scheduleObj, setScheduleObj] = useState(scheduleObjIntial);
  const [renderDaysSchedules, setRenderDaysSchedules] = useState([]);
  const [yearlySchedule, setYearlySchedule] = useState({
    year: "",
    month: "",
    day: "",
    time: 0,
  });

  const [multipledailySchedule, setmultipleDailySchedule] = useState([
    { time: 0, isDisabled: false },
  ]);
  const [monthSelect, setMonthSelect] = useState([]);
  const [monthSelectRender, setMonthSelectRender] = useState([]);
  const [yearSelect, setyearSelect] = useState([]);
  const [yearSelectRender, setYearSelectRender] = useState([]);
  const [daySelect, setDaySelect] = useState([]);
  const [daySelectRender, setDaySelectRender] = useState([]);
  const [timeSelect, setTimeSelect] = useState([]);
  const [timeSelectRender, setTimeSelectRender] = useState([]);
  const [flagTocheckIsEdit, setFlagTocheckIsEdit] = useState(false);
  const [errorMessage, setErrorMessage] = useState([{ error: "" }]);
  const [buttonDisableFlag, setButtonDisableFlag] = useState(false);
  const [deleteFlag, setDeleteFlag] = useState(false);
  const [isLeap, setIsLeap] = useState(false);
  const [checkPlanEdit, setCheckPlanEdit] = useState(false);
  const scrollRef = useRef();
  const [isNextPage, setIsNextPage] = useState(false);
  const [open, setOpen] = useState(false);
  const [currentBlockIndex, setCurrentBlockIndex] = useState(0);
  const [currentChapterIndex, setCurrentChapterIndex] = useState(0);
  const [isPruefGroupTestCriteria, setIsPruefGroupTestCriteria] =
    useState(true);
  const [shouldTakeEquipmentOutOfOrder, setShouldTakeEquipmentOutOfOrder] =
    useState(false);
  const [isChecklistFeedbackMandatory, setIsChecklistFeedbackMandatory] =
    useState("No");
  const [isImageRequired, setIsImageRequired] = useState("No");
  const [egList, setEgList] = useState([]);
  const [isPublish, setIsPublish] = useState(false);
  const [confirmationPopUpOpen, setConfirmationPopUpOpen] = useState(false);
  const [confirmationPopUpMsg, setConfirmationPopUpMsg] = useState("");
  const [callbackData, setCallbackData] = useState(null);
  const [eventType, setEventType] = useState(null);
  const initState = [];
  const [checklistObj, setChecklistObj] = useState({
    checklistChapterModels: initState,
  });

  function weekDays() {
    return [
      { day: localization.monday, isChecked: false, value: "1" },
      { day: localization.tuesday, isChecked: false, value: "2" },
      { day: localization.wednesday, isChecked: false, value: "3" },
      { day: localization.thursday, isChecked: false, value: "4" },
      { day: localization.friday, isChecked: false, value: "5" },
      { day: localization.saturday, isChecked: false, value: "6" },
      { day: localization.sunday, isChecked: false, value: "0" },
    ];
  }
  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  useEffect(() => {
    if (props.checkListDetails) {
      setCurrentPruefPlan(props.checkListDetails);
    }
    return () => {};
  }, [props]);

  //------------------------Setting Day start ----------------------

  useEffect(() => {
    if (!checkPlanEdit) {
      if (yearlySchedule.day !== "") {
        setYearlySchedule({
          ...yearlySchedule,
          ["day"]: "",
          ["month"]: "",
        });
      }
      isLeapYear(parseInt(yearlySchedule.year));
    }
  }, [yearlySchedule.year]);
  //------------------------Setting Day End ------------------------

  //------------------------Schedule Configuration start ----------------------

  useEffect(() => {
    if (!flagTocheckIsEdit) {
      setFrequencySchedules("");
      setYearlySchedule({ year: "", month: "", day: "", time: 0 });
    }
  }, [numberOfSchedules]);

  useEffect(() => {
    if (numberOfSchedules === "Multiple" && frequencySchedules != "") {
      setButtonDisableFlag(true);
    }

    if (
      numberOfSchedules === "Multiple" &&
      frequencySchedules != "" &&
      multipledailySchedule.length > 0
    ) {
      const formtime = [];
      const formError = [];
      const formValue = [...multipledailySchedule];
      const formErrorValue = [...errorMessage];
      formValue.map((item) => {
        formtime.push(item.time);
      });
      formErrorValue.map((item) => formError.push(item));
      const IsValue = formtime.some((element) => element === "");
      const IsError = formError.some((element) => element.error != "");
      const Isbutton = IsValue || IsError ? true : false;
      setButtonDisableFlag(Isbutton);
    }
    setFlagTocheckIsEdit(false);
  }, [multipledailySchedule]);

  useEffect(() => {
    let render = [];
    let renderDays = [];
    let renderTime = [];
    let renderYear = [];
    for (let i = 0; i < 12; i++) {
      render.push({ value: i + 1 });
    }
    for (let i = 0; i < 31; i++) {
      renderDays.push({ value: i + 1 });
    }
    for (let i = 0; i < 24; i++) {
      renderTime.push({ value: i });
    }
    for (
      let i = new Date().getFullYear() - 10;
      i < new Date().getFullYear() + 10;
      i++
    ) {
      renderYear.push({ value: i });
    }
    setDaySelect(renderDays);
    setMonthSelect(render);
    setTimeSelect(renderTime);
    setyearSelect(renderYear);
  }, []);

  useEffect(() => {
    if (timeSelect.length > 0) {
      const item = timeSelect.map((element, index) => {
        return (
          <option value={element.value} key={index}>
            {element.value}
          </option>
        );
      });
      setTimeSelectRender(item);
    }
  }, [timeSelect]);

  useEffect(() => {
    if (monthSelect.length > 0) {
      const item = monthSelect.map((element, index) => {
        return (
          <option value={element.value} key={index}>
            {element.value}
          </option>
        );
      });
      setMonthSelectRender(item);
    }
  }, [monthSelect]);

  useEffect(() => {
    if (yearSelect.length > 0) {
      const item = yearSelect.map((element, index) => {
        return (
          <option value={element.value} key={index}>
            {element.value}
          </option>
        );
      });
      setYearSelectRender(item);
    }
  }, [yearSelect]);

  useEffect(() => {
    if (!checkPlanEdit) {
      setYearlySchedule({
        ...yearlySchedule,
        ["day"]: "",
      });
    }

    if (daySelect.length > 0) {
      let isMonth30;
      if (yearlySchedule.month === 8) {
        isMonth30 = false;
      } else {
        if (yearlySchedule.month > 8) {
          if (yearlySchedule.month % 2 === 0) {
            isMonth30 = false;
          } else {
            isMonth30 = true;
          }
        } else {
          if (yearlySchedule.month % 2 === 0) {
            isMonth30 = true;
          } else {
            isMonth30 = false;
          }
        }
      }
      const item = daySelect.map((element, index) => {
        if (yearlySchedule.month === 2) {
          if (isLeap && element.value < 30) {
            return (
              <option value={element.value} key={index}>
                {element.value}
              </option>
            );
          } else {
            if (!isLeap && element.value < 29) {
              return (
                <option value={element.value} key={index}>
                  {element.value}
                </option>
              );
            }
          }
        } else {
          if (isMonth30 && element.value < 31) {
            return (
              <option value={element.value} key={index}>
                {element.value}
              </option>
            );
          } else {
            if (!isMonth30 && element.value < 32) {
              return (
                <option value={element.value} key={index}>
                  {element.value}
                </option>
              );
            }
          }
        }
      });
      setDaySelectRender(item);
    }
  }, [yearlySchedule.month]);

  function getEquipmentGroupByOrganisations() {
    EquipmentGroupActions.getOrganisationsEquipmentGroup();
  }

  useEffect(() => {
    getEquipmentGroupByOrganisations();

    function getEquipmentGroupSuccess() {
      const res = equipmentGroupStore.getOrgEquipmentGroupResult();
      if (res.length > 0) {
        let sortList = res.sort((a, b) =>
          a.werk > b.werk ? 1 : a.werk < b.werk ? -1 : 0,
        );
        setEgList(sortList);
      } else {
        setEgList([]);
      }
    }
    function getEquipmentGroupFailure() {
      setGlobalSpinner(false);
    }
    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.GET_ORG_EQUIPMENT_SUCCESS,
      getEquipmentGroupSuccess,
    );
    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.GET_ORG_EQUIPMENT_FAILURE,
      getEquipmentGroupFailure,
    );
    return () => {
      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.GET_ORG_EQUIPMENT_SUCCESS,
        getEquipmentGroupSuccess,
      );
      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.GET_ORG_EQUIPMENT_FAILURE,
        getEquipmentGroupFailure,
      );
    };
  }, []);

  useEffect(() => {
    if (egId) {
      getEquipmentGroupByOrganisations();
      setEquipmentGroupId(egId);
      setCurrentPruefPlanId(pruefPlanId);
      setegName(equipmentGroupName);
    }
  }, [egId]);

  useEffect(() => {
    if (!flagTocheckIsEdit) {
      setYearlySchedule({ year: "", month: "", day: "", time: 0 });
      setNumberOfSchedules("Single");
      setFrequencySchedules("");
      setDaysCheck(weekDays);
    }
    setButtonDisableFlag(false);
    setErrorMessage({ error: "" });
  }, [purefPlanData.turnuszyklus]);

  useEffect(() => {
    const item = frequencySchedules === "" ? 0 : parseInt(frequencySchedules);
    let intermediateItem = [];
    let errormessage = [];
    if (item) {
      if (!flagTocheckIsEdit) {
        for (let i = 0; i < item; i++) {
          errormessage.push({ error: "" });
        }
        setErrorMessage(errormessage);
        for (let i = 0; i < item; i++) {
          intermediateItem.push({
            time: "",
            isDisabled: i === 0 ? false : true,
          });
        }

        setmultipleDailySchedule(intermediateItem);
      }
    } else {
      errormessage.push({ error: "" });
      setErrorMessage(errormessage);
      intermediateItem.push({ time: "", isDisabled: false });
      setmultipleDailySchedule(intermediateItem);
    }
  }, [frequencySchedules]);

  useEffect(() => {
    if (multipledailySchedule.length > 0) {
      const renderitem = multipledailySchedule.map((item, i) => (
        <Fragment key={i}>
          <div className="row ml-0" key={i}>
            <div className="col colpadding">
              <label className="form-label" htmlFor="time">
                {`${localization.startTimeSchedule}-${i + 1} `}
              </label>
            </div>
          </div>
          <div className="row mt-1" key={i + 1}>
            <div className="col-3">
              <select
                className={`form-control ${
                  errorMessage[i].error != "" ? "border-danger" : ""
                }`}
                id={`time ${i}`}
                name={`time ${i}`}
                disabled={item.isDisabled || viewModeOnly}
                required
                value={item.time}
                onChange={(e) => {
                  handleMultipleSchedule(e, i);
                }}
              >
                <option value="" disabled>
                  {localization.select}
                </option>
                {timeSelectRender}
              </select>
            </div>
            <label
              className={`form-label ml-4 ${
                errorMessage[i].error != "" ? "text-danger" : ""
              }`}
              htmlFor="error"
            >
              {errorMessage[i].error}
            </label>
          </div>
        </Fragment>
      ));
      const item = (
        <>
          <div className="row d-flex flex-column form-group formGroupBack">
            {renderitem}
          </div>
        </>
      );
      setRenderDaysSchedules(item);
    }
  }, [multipledailySchedule]);

  useEffect(() => {
    if (scheduleObj.fixedSchedule) {
      setScheduleObj({ ...scheduleObj, ["toleranceCheck"]: 0 });
    }
    setYearlySchedule({ year: "", month: "", day: "", time: 0 });
    setmultipleDailySchedule({ time: "", isDisabled: false });
    setErrorMessage({ error: "" });
    setNumberOfSchedules("Single");
  }, [scheduleObj.fixedSchedule]);

  //------------------------Schedule End Configuration start ----------------------

  //------------------------get KostPruefGroup based on equipmentGroupId start ----------------------

  function getKostPruefGroup(equipmentGroupId) {
    setGlobalSpinner(true);
    Pruef_PlanActions.getKostPruefGroups(equipmentGroupId);
  }
  useEffect(() => {
    setKostPruefGroupsList([]);
    if (equipmentGroupId) {
      getKostPruefGroup(equipmentGroupId);
    } else {
      purefPlanData.turnuszyklus = "A";
    }
  }, [equipmentGroupId]);

  useEffect(() => {
    function getKostPruefGroupsSuccess() {
      const res = pruefPlanStores.getKostPruefGroups();

      if (res) {
        setIsPruefGroupTestCriteria(res.isPruefGroupTestCriteria);
        setKostPruefGroupsList(res.kostPruefGroups);
      } else {
        setKostPruefGroupsList([]);
      }
      setGlobalSpinner(false);
    }
    function getKostPruefGroupsFailure() {
      const res = pruefPlanStores.getKostPruefGroups();
      setGlobalSpinner(false);
    }
    pruefPlanStores.addChangeListener(
      pruef_PlanConstants.GET_KostPruefGroups_SUCCESS,
      getKostPruefGroupsSuccess,
    );
    pruefPlanStores.addChangeListener(
      pruef_PlanConstants.GET_KostPruefGroups_FAILURE,
      getKostPruefGroupsFailure,
    );
    return () => {
      pruefPlanStores.removeChangeListener(
        pruef_PlanConstants.GET_KostPruefGroups_SUCCESS,
        getKostPruefGroupsSuccess,
      );
      pruefPlanStores.removeChangeListener(
        pruef_PlanConstants.GET_KostPruefGroups_FAILURE,
        getKostPruefGroupsFailure,
      );
    };
  }, []);

  //------------------------get KostPruefGroup END on equipmentGroupId start ----------------------

  //------------------------Edit PrufePlan start ----------------------
  //------------------------Edit PrufePlan start ----------------------
  useEffect(() => {
    if (currentPruefPlan) {
      setFlagTocheckIsEdit(true);
      commonUtils.setIsEdit(false);
      let currentPruefPlanValue = [];
      setEquipmentGroupId(
        currentPruefPlan.anlagegruppeId ? currentPruefPlan.anlagegruppeId : 0,
      );
      currentPruefPlanValue.push({
        checklistTitle: currentPruefPlan.title,
        checklistDesc: currentPruefPlan.description,
        ChecklistNr: currentPruefPlan.checklistNr,
        turnusanzahl: currentPruefPlan.duration,
        turnuszyklus: currentPruefPlan.frequency,
        kurzbezeichnung: currentPruefPlan.abbreviation,
        kostPruefGroupsId: currentPruefPlan.testGroupId
          ? currentPruefPlan.testGroupId
          : currentPruefPlan.kostGroupId,
      });
      setpurefPlanData(currentPruefPlanValue[0]);
      setegName(equipmentGroupName);
      currentPruefPlan
        ? commonUtils.setIsEdit(true)
        : commonUtils.setIsEdit(false);
      setScheduleObj({
        fixedSchedule: currentPruefPlan.fixedSchedule,
        toleranceCheck: currentPruefPlan.checkTolerance,
        generateInspection: currentPruefPlan.generateAllInspectionSchedules,
        deleteInspection:
          currentPruefPlan.deleteInspection == 36500
            ? ""
            : currentPruefPlan.deleteInspection,
        deleteInspectionPhoto:
          currentPruefPlan.deleteInspectionPhoto == 36500
            ? ""
            : currentPruefPlan.deleteInspectionPhoto,
      });
      setIsImageRequired(currentPruefPlan.photoNeeded);
      setDeleteFlag(currentPruefPlan.deleteInspection === 36500 ? false : true);
      if (currentPruefPlan.fixedSchedule) {
        if (currentPruefPlan.frequency != "D") {
          setCheckPlanEdit(true);
          isLeapYear(currentPruefPlan.schedules.year);
          setYearlySchedule({
            year: currentPruefPlan.schedules.year,
            month: currentPruefPlan.schedules.month,
            day: currentPruefPlan.schedules.day,
            time: currentPruefPlan.schedules.time,
          });
        } else {
          if (currentPruefPlan.schedules.time.length > 1) {
            setNumberOfSchedules("Multiple");
            const errorCount = [];
            for (let i = 0; i < currentPruefPlan.schedules.time.length; i++) {
              errorCount.push({ error: "" });
            }
            setErrorMessage(errorCount);
            setFrequencySchedules(currentPruefPlan.schedules.time.length);
            let timeSlot = [];
            currentPruefPlan.schedules.time.map((item) =>
              timeSlot.push({ time: item, isDisabled: false }),
            );
            setYearlySchedule({
              year: "",
              month: "",
              day: "",
              time: 0,
            });
            setmultipleDailySchedule(timeSlot);
          } else {
            setNumberOfSchedules("Single");
            setYearlySchedule({
              year: currentPruefPlan.schedules.year,
              month: currentPruefPlan.schedules.month,
              day: currentPruefPlan.schedules.day,
              time: currentPruefPlan.schedules.time,
            });
            setmultipleDailySchedule({ time: 0, isDisabled: false });
          }
        }
      }
      if (currentPruefPlan.frequency === "D") {
        let weekdays = [...daysCheck];
        weekdays.map((item) => {
          if (currentPruefPlan.excludeDays.includes(item.value)) {
            item.isChecked = true;
          }
        });
        setDaysCheck(weekdays);
      }
      setShouldTakeEquipmentOutOfOrder(
        currentPruefPlan.shouldTakeEquipmentOutOfOrder,
      );
      setIsChecklistFeedbackMandatory(
        currentPruefPlan.isChecklistFeedbackMandatory,
      );
      currentPruefPlan.checklistChapterModels.map((chapter, chapterIndex) => {
        chapter.checklistBlockModels.map((block, blockIndex) => {
          if (block.files.length > 0) {
            block["addMedia"] = true;
          } else {
            block["addMedia"] = false;
          }
        });
      });
      setChecklistObj({
        checklistChapterModels: currentPruefPlan.checklistChapterModels,
      });
    } else {
      setpurefPlanData(pruefplanIntial);
      setScheduleObj(scheduleObjIntial);
      setDaysCheck(weekDays);
      setErrorMessage({ error: "" });
      setFlagTocheckIsEdit(false);
      setNumberOfSchedules("Single");
      setButtonDisableFlag(false);
      setDeleteFlag(false);
    }
  }, [currentPruefPlan]);

  //------------------------Edit PrufePlan End ----------------------

  function closePrufePlanCallback() {
    setpurefPlanData(pruefplanIntial);
    setEquipmentGroupId(0);
    setCurrentPruefPlanId(0);
    setCurrentPruefPlan("");
    setegName("");
    setScheduleObj(scheduleObjIntial);
    setDaysCheck(weekDays);
    setErrorMessage({ error: "" });
    setFlagTocheckIsEdit(false);
    setNumberOfSchedules("Single");
    setDeleteFlag(false);
    setButtonDisableFlag(false);
    setShouldTakeEquipmentOutOfOrder(false);
    setIsChecklistFeedbackMandatory("No");
    setChecklistObj({ checklistChapterModels: initState });
    setIsNextPage(false);
    closePrufePlanEditPopUpCallback();
  }
  const pruefPlanAdd = (e) => {
    e.preventDefault();
    if (!isNextPage) {
      var form = document.getElementById("addDigitalChecklistForm");
      if (form.checkValidity()) {
        setIsNextPage(true);
      }
    } else if (validateCheckList()) {
      let requestData = constructFinalRequestData();
      setGlobalSpinner(true);
      Pruef_PlanActions.saveUpdateChecklist(requestData, isPublish);
    }
  };

  const handleSaveAsTemplate = () => {
    if (validateCheckList()) {
      let requestData = constructFinalRequestData();
      setIsCreateTemplateModalOpen(true);
      setChecklistDataForTemplate(requestData);
    }
  };

  function constructFinalRequestData() {
    let excludeDays = [];
    let inceptionSchedule = { year: 0, month: 0, day: 0, time: [] };
    if (numberOfSchedules === "Multiple") {
      multipledailySchedule.map((item) => {
        inceptionSchedule.time.push(item.time);
      });
    } else {
      inceptionSchedule.year =
        yearlySchedule.year === "" ? 0 : yearlySchedule.year;
      inceptionSchedule.month =
        yearlySchedule.month === "" ? 0 : yearlySchedule.month;
      inceptionSchedule.day =
        yearlySchedule.day === "" ? 0 : yearlySchedule.day;
      if (purefPlanData.turnuszyklus === "D")
        inceptionSchedule.time.push(
          yearlySchedule.time.length > 0
            ? yearlySchedule.time[0]
            : yearlySchedule.time,
        );
    }
    daysCheck.map((item) => {
      if (item.isChecked === true) {
        excludeDays.push(item.value);
      }
    });
    checklistObj.checklistChapterModels.map((chapter) => {
      chapter.checklistBlockModels.map((block) => {
        block.pruefFragenItemModels.map((question) => {
          if (question.answerType == "Yes/No") {
            if (question.defaultAnswer == "true") {
              question.defaultAnswer = true;
            } else if (question.defaultAnswer == "false") {
              question.defaultAnswer = false;
            }
          }
          if (!question.shouldTakeEquipmentOutOfOrder) {
            question.antwort = "";
          }
        });
      });
    });

    const pruefPlanItem = {
      title: purefPlanData.checklistTitle,
      description: purefPlanData.checklistDesc,
      ChecklistNr: purefPlanData.ChecklistNr,
      Abbreviation: purefPlanData.kurzbezeichnung,
      Duration: parseInt(purefPlanData.turnusanzahl),
      Frequency: equipmentGroupId == "" ? "A" : purefPlanData.turnuszyklus,
      AnlagegruppeId: equipmentGroupId == "" ? null : equipmentGroupId,
      ExcludeDays: excludeDays.length > 0 ? excludeDays : [],
      Schedules: scheduleObj.fixedSchedule
        ? {
            Year: inceptionSchedule.year,
            Month: inceptionSchedule.month,
            Day: inceptionSchedule.day,
            Time: inceptionSchedule.time,
          }
        : {
            Year: 0,
            Month: 0,
            Day: 0,
            Time: [],
          },
      FixedSchedule: scheduleObj.fixedSchedule,
      PhotoNeeded: isImageRequired,
      CheckTolerance: scheduleObj.fixedSchedule
        ? parseInt(scheduleObj.toleranceCheck)
        : 0,
      GenerateAllInspectionSchedules: scheduleObj.generateInspection,
      DeleteInspection:
        isNaN(scheduleObj.deleteInspection) || scheduleObj.deleteInspection == 0
          ? 36500
          : scheduleObj.deleteInspection,
      DeleteInspectionPhoto:
        isNaN(scheduleObj.deleteInspectionPhoto) ||
        scheduleObj.deleteInspectionPhoto == 0
          ? 36500
          : scheduleObj.deleteInspectionPhoto,
      ShouldTakeEquipmentOutOfOrder: shouldTakeEquipmentOutOfOrder,
      isChecklistFeedbackMandatory: isChecklistFeedbackMandatory,
      checklistChapterModels: checklistObj.checklistChapterModels,
    };

    if (equipmentGroupId && equipmentGroupId != "") {
      if (isPruefGroupTestCriteria) {
        pruefPlanItem.TestGroupId = purefPlanData.kostPruefGroupsId;
      } else {
        pruefPlanItem.KostGroupId = purefPlanData.kostPruefGroupsId;
      }
    }

    if (
      !isChecklistFromTemplate &&
      currentPruefPlan &&
      currentPruefPlan.referenceID != ""
    ) {
      pruefPlanItem.ReferenceID = currentPruefPlan.referenceID;
    }

    if (currentPruefPlan && currentPruefPlan.version != "") {
      pruefPlanItem.version = currentPruefPlan.version;
    }

    return pruefPlanItem;
  }

  function handlePruefPlan(e) {
    e.preventDefault();
    const { name, value } = e.target;
    let _value = "";
    if (purefPlanData[name] !== "") {
      _value = value;
    } else {
      _value = value.trim();
    }
    setpurefPlanData({
      ...purefPlanData,
      [name]: _value,
    });
    setFlagTocheckIsEdit(false);
  }

  function handlePruefPlanScheduleBoolen(e) {
    e.preventDefault();
    if (e.target.value === "false" || "true") {
      const item = e.target.value === "false" ? false : true;
      setScheduleObj({ ...scheduleObj, [e.target.name]: item });
    }
  }

  function handlePruefPlanSchedule(e) {
    e.preventDefault();
    let { name, value } = e.target;
    if (name === "deleteInspection" || name === "deleteInspectionPhoto") {
      value = parseInt(value);
    }
    if (name === "deleteInspection") {
      if (scheduleObj.deleteInspection < 1 || scheduleObj.deleteInspection) {
        const valuedeleteInspection = value > 0 ? 1 : 0;
        const deleteInspectionPhotoName = "deleteInspectionPhoto";
        setDeleteFlag(valuedeleteInspection ? true : false);
        scheduleObj[deleteInspectionPhotoName] = "";
      }
    }
    setScheduleObj({ ...scheduleObj, [name]: value });
  }

  function handleInspectionSchedule(e) {
    e.preventDefault();
    if (checkPlanEdit) {
      setCheckPlanEdit(false);
    }
    const nameItem = e.target.name;
    const valueItem = parseInt(e.target.value);
    setYearlySchedule({
      ...yearlySchedule,
      [nameItem]: valueItem,
    });
  }

  function handleMultipleSchedule(e, index) {
    e.preventDefault();
    let beforeValue = [];
    let afterValue = [];
    let afterResult = false;
    let beforeResult = false;
    let errorIndex = [];
    let ValueIndex = [];
    const { name, value } = e.target;
    let res = [...errorMessage];
    const freqSched = parseInt(frequencySchedules);
    const itemName = "time";
    const itemValue = parseInt(value);
    const formValue = [...multipledailySchedule];
    res.map((item, i) => {
      if (item.error !== "") {
        errorIndex.push(i);
      }
    });
    if (errorIndex.length > 0) {
      errorIndex.map((element) => {
        if (element === index) {
          return;
        } else {
          if (element === index + 1) {
            if (
              errorMessage[element].error ===
              localization.timeslotshouldbeGreaterthenPreviousSlot
            ) {
              if (itemValue < formValue[element].time) {
                errorMessage[element].error = "";
              }
            }
          } else {
            if (element === index - 1) {
              if (
                errorMessage[element].error ===
                localization.timeSlotShouldbeLesserThantheSucceedingSlot
              ) {
                if (itemValue > formValue[element].time) {
                  errorMessage[element].error = "";
                }
              }
            }
            {
            }
          }
        }
      });
    }
    formValue.map((item, i) => {
      if (item.time > 0 && i > index) {
        afterValue.push(item.time);
      } else {
        if (item.time > 0 && i < index) {
          beforeValue.push(item.time);
        }
      }
    });
    formValue.map((item, i) => {
      if (isNaN(item.time)) {
        ValueIndex.push(i);
      }
    });
    if (afterValue.length > 0) {
      afterResult = afterValue.some(
        (element) => element < itemValue || element == itemValue,
      );
    }
    if (beforeValue.length > 0) {
      beforeResult = beforeValue.some(
        (element) => element > itemValue || element == itemValue,
      );
    }

    if (afterResult || beforeResult) {
      res[index].error = afterResult
        ? localization.timeSlotShouldbeLesserThantheSucceedingSlot
        : localization.timeslotshouldbeGreaterthenPreviousSlot;
      formValue.map((item, i) => {
        if (i > index) {
          item.isDisabled = flagTocheckIsEdit
            ? false
            : ValueIndex.length > 0
              ? true
              : false;
        }
      });
      formValue[index][itemName] = itemValue;
      setErrorMessage(res);
      setmultipleDailySchedule(formValue);
    } else {
      if (index != freqSched - 1) {
        formValue[index + 1]["isDisabled"] = false;
      }
      res[index].error = "";
      setErrorMessage(res);
      formValue[index][itemName] = itemValue;
      setmultipleDailySchedule(formValue);
    }
  }

  function handlecheckBox(items) {
    const temp = daysCheck.map((item, index) =>
      item.day === items.day
        ? { ...item, isChecked: items.isChecked ? false : true }
        : item,
    );
    setDaysCheck(temp);
  }

  /* <>--------------------------------------------------------------------Test Leap Year  Start----------------------------------------------------------<> */
  function isLeapYear(year) {
    if (
      year !== "" &&
      year % 4 === 0 &&
      (year % 100 !== 0 || year % 400 === 0)
    ) {
      setIsLeap(true);
    } else {
      setIsLeap(false);
    }
  }
  /* <>--------------------------------------------------------------------Test Leap Year  End----------------------------------------------------------<> */
  function addNewChapter() {
    var tempObj = { ...checklistObj };
    tempObj.checklistChapterModels.push({
      title: "",
      isMandatory: false,
      position: tempObj.checklistChapterModels.length + 1,
      checklistBlockModels: [],
    });
    setChecklistObj(tempObj);
  }

  function addNewBlock(chapterIndex) {
    var tempObj = { ...checklistObj };
    tempObj.checklistChapterModels[chapterIndex].checklistBlockModels.push({
      title: "",
      description: "",
      isMandatory: tempObj.checklistChapterModels[chapterIndex].isMandatory,
      position:
        tempObj.checklistChapterModels[chapterIndex].checklistBlockModels
          .length + 1,
      pruefFragenItemModels: [],
      addMedia: false,
      files: [],
    });
    setChecklistObj(tempObj);
  }

  function addMedia(e, chapterIndex, blockIndex) {
    var tempObj = { ...checklistObj };
    tempObj.checklistChapterModels[chapterIndex].checklistBlockModels[
      blockIndex
    ].addMedia = e.target.checked;
    setChecklistObj(tempObj);
  }

  function handleOnchange(event, chapterIndex, blockIndex) {
    var files = [...event.target.files];
    let tempFileArray = [];
    var tempObj = { ...checklistObj };
    var areAllImageFiles = true;
    if (files && files.length > 0) {
      files.map((file) => {
        if (!file.type.startsWith("image/")) {
          toast.error("Please upload only images");
          areAllImageFiles = false;
        }
      });
      if (areAllImageFiles) {
        files.forEach((file, index) => {
          let reader = new FileReader();
          reader.onload = () => {
            tempFileArray.push({
              filename: file.name,
              filecontent: reader.result,
              filetyp: file.type,
              fileContentBytes: null,
            });

            if (index === files.length - 1) {
              tempFileArray.map((item) => {
                tempObj.checklistChapterModels[
                  chapterIndex
                ].checklistBlockModels[blockIndex].files.push(item);
              });
              setChecklistObj(tempObj);
            }
          };
          reader.onerror = () => {};

          reader.readAsDataURL(file);
        });
      }
    }
  }

  const handleClose = () => {
    setOpen(false);
  };

  const addTemplate = (selectedTemplateData) => {
    selectedTemplateData.map((selectedTemplate, index) => {
      for (var i = 0; i < selectedTemplate.count; i++) {
        checklistObj.checklistChapterModels[
          currentChapterIndex
        ].checklistBlockModels[currentBlockIndex].pruefFragenItemModels.push({
          frage: "",
          lfdNr: "",
          isMandatory:
            checklistObj.checklistChapterModels[currentChapterIndex]
              .isMandatory ||
            checklistObj.checklistChapterModels[currentChapterIndex]
              .checklistBlockModels[currentBlockIndex].isMandatory ||
            shouldTakeEquipmentOutOfOrder,
          antwort:
            shouldTakeEquipmentOutOfOrder && selectedTemplate.type == "Yes/No"
              ? "J"
              : "",
          answerType: selectedTemplate.type,
          position:
            checklistObj.checklistChapterModels[currentChapterIndex]
              .checklistBlockModels[currentBlockIndex].pruefFragenItemModels
              .length + 1,
          shouldTakeEquipmentOutOfOrder: shouldTakeEquipmentOutOfOrder,
          defaultAnswer: null,
          radioOption: "",
          rangeValue:
            selectedTemplate.type == "RangeValue"
              ? {
                  min: "",
                  max: "",
                }
              : null,
          canCreateTicket: false,
        });
      }
    });
    handleClose();
  };

  const InlineEditableInput = (props) => {
    const {
      name,
      type,
      placeholder,
      keyName,
      objToUpdate,
      chapterindex,
      blockindex,
      questionindex,
      initialValue,
      onSave,
    } = props;
    const [value, setValue] = useState(initialValue);
    const [isEditing, setIsEditing] = useState(false);

    const handleInputChange = (e) => {
      setValue(e.target.value);
    };

    const handleSave = () => {
      if (objToUpdate == "Chapter") {
        onSave(keyName, chapterindex, value);
      } else if (objToUpdate == "Block") {
        onSave(keyName, chapterindex, blockindex, value);
      }
      setIsEditing(false);
    };
    switch (type) {
      case "text":
        return (
          <div>
            {isEditing ? (
              <input
                type={type}
                name={name}
                value={value}
                placeholder={placeholder}
                onChange={handleInputChange}
                onBlur={handleSave}
                autoFocus
                required
              />
            ) : (
              <>
                <span className={`${value == "" ? "requiredCls" : ""}`}>
                  {value || placeholder}
                </span>
                <MdEdit
                  className="inlineEditIcon"
                  title={localization.edit}
                  onClick={() => setIsEditing(true)}
                />
              </>
            )}
            <MdDeleteOutline
              className="float-right"
              style={{ cursor: "pointer" }}
              title={
                objToUpdate == "Chapter"
                  ? localization.deleteChapter
                  : localization.deleteBlock
              }
              size={20}
              onClick={(e) => {
                deleteChapterAndBlock(objToUpdate, chapterindex, blockindex);
              }}
            />
          </div>
        );
      case "Description":
        return (
          <div>
            {isEditing ? (
              <textarea
                name={name}
                value={value}
                placeholder={placeholder}
                cols={50}
                onChange={handleInputChange}
                onBlur={handleSave}
                autoFocus
              />
            ) : (
              <div onClick={() => setIsEditing(true)}>
                <span>{value || placeholder}</span>
                <MdEdit
                  className="inlineEditIcon"
                  title={localization.edit}
                />{" "}
              </div>
            )}
          </div>
        );
    }
  };

  function updateChapterDetails(key, chapterIndex, value) {
    var tempObj = { ...checklistObj };
    switch (key) {
      case "Title":
        tempObj.checklistChapterModels[chapterIndex].title = value;
        break;
      case "IsMandatory":
        tempObj.checklistChapterModels[chapterIndex].isMandatory = value;
        break;
    }
    setChecklistObj(tempObj);
  }

  function updateBlockDetails(key, chapterIndex, blockindex, value) {
    var tempObj = { ...checklistObj };
    switch (key) {
      case "Title":
        tempObj.checklistChapterModels[chapterIndex].checklistBlockModels[
          blockindex
        ].title = value;
        break;
      case "IsMandatory":
        tempObj.checklistChapterModels[chapterIndex].checklistBlockModels[
          blockindex
        ].isMandatory = value;
        break;
      case "Description":
        tempObj.checklistChapterModels[chapterIndex].checklistBlockModels[
          blockindex
        ].description = value;
        break;
    }
    setChecklistObj(tempObj);
  }

  function updateQuestionDetails(
    key,
    chapterIndex,
    blockindex,
    questionindex,
    value,
    answerType,
  ) {
    var tempObj = { ...checklistObj };
    switch (key) {
      case "Title":
        tempObj.checklistChapterModels[chapterIndex].checklistBlockModels[
          blockindex
        ].pruefFragenItemModels[questionindex].frage = value;

        tempObj.checklistChapterModels[chapterIndex].checklistBlockModels[
          blockindex
        ].pruefFragenItemModels[questionindex].answerType = answerType;
        break;
      case "IsMandatory":
        tempObj.checklistChapterModels[chapterIndex].checklistBlockModels[
          blockindex
        ].pruefFragenItemModels[questionindex].isMandatory = value;
        break;
      case "ShouldTakeEquipmentOutOfOrder":
        tempObj.checklistChapterModels[chapterIndex].checklistBlockModels[
          blockindex
        ].pruefFragenItemModels[questionindex].shouldTakeEquipmentOutOfOrder =
          value;
        if (
          !tempObj.checklistChapterModels[chapterIndex].isMandatory &&
          !tempObj.checklistChapterModels[chapterIndex].checklistBlockModels[
            blockindex
          ].isMandatory &&
          !value
        ) {
          tempObj.checklistChapterModels[chapterIndex].checklistBlockModels[
            blockindex
          ].pruefFragenItemModels[questionindex].isMandatory = value;
        }
        break;
      case "ExpectedAnswer":
        tempObj.checklistChapterModels[chapterIndex].checklistBlockModels[
          blockindex
        ].pruefFragenItemModels[questionindex].antwort = value;
        break;
      case "DefaultAnswer":
        tempObj.checklistChapterModels[chapterIndex].checklistBlockModels[
          blockindex
        ].pruefFragenItemModels[questionindex].defaultAnswer = value;
        break;
      case "RadioOption":
        tempObj.checklistChapterModels[chapterIndex].checklistBlockModels[
          blockindex
        ].pruefFragenItemModels[questionindex].radioOption = value;
        break;
      case "RangeMinValue":
        let rangeObj1 =
          tempObj.checklistChapterModels[chapterIndex].checklistBlockModels[
            blockindex
          ].pruefFragenItemModels[questionindex].rangeValue;

        if (rangeObj1) {
          tempObj.checklistChapterModels[chapterIndex].checklistBlockModels[
            blockindex
          ].pruefFragenItemModels[questionindex].rangeValue["min"] =
            parseFloat(value);
        } else {
          tempObj.checklistChapterModels[chapterIndex].checklistBlockModels[
            blockindex
          ].pruefFragenItemModels[questionindex].rangeValue = {
            min: 0,
            max: 0,
          };
        }
        break;
      case "RangeMaxValue":
        let rangeObj2 =
          tempObj.checklistChapterModels[chapterIndex].checklistBlockModels[
            blockindex
          ].pruefFragenItemModels[questionindex].rangeValue;

        if (rangeObj2) {
          tempObj.checklistChapterModels[chapterIndex].checklistBlockModels[
            blockindex
          ].pruefFragenItemModels[questionindex].rangeValue["max"] =
            parseFloat(value);
        } else {
          tempObj.checklistChapterModels[chapterIndex].checklistBlockModels[
            blockindex
          ].pruefFragenItemModels[questionindex].rangeValue = {
            min: 0,
            max: 0,
          };
        }
        break;
      case "CanCreateTicket":
        tempObj.checklistChapterModels[chapterIndex].checklistBlockModels[
          blockindex
        ].pruefFragenItemModels[questionindex].canCreateTicket = value;
        break;
    }
    setChecklistObj(tempObj);
  }

  function deleteQuestion(chapterindex, blockindex, questionindex) {
    var tempObj = { ...checklistObj };
    var remainingQuestions = tempObj.checklistChapterModels[
      chapterindex
    ].checklistBlockModels[blockindex].pruefFragenItemModels.filter(
      (question, index) => {
        return index != questionindex;
      },
    );
    tempObj.checklistChapterModels[chapterindex].checklistBlockModels[
      blockindex
    ].pruefFragenItemModels = [];
    remainingQuestions.map((question, index) => {
      question.position = index + 1;
      tempObj.checklistChapterModels[chapterindex].checklistBlockModels[
        blockindex
      ].pruefFragenItemModels.push(question);
    });
    setChecklistObj(tempObj);
  }

  function deleteChapterAndBlock(objToUpdate, chapterindex, blockindex) {
    var tempObj = { ...checklistObj };
    if (objToUpdate == "Chapter") {
      var remainingChapters = tempObj.checklistChapterModels.filter(
        (chapter, index) => {
          return index != chapterindex;
        },
      );
      tempObj.checklistChapterModels = [];
      remainingChapters.map((chapter, index) => {
        chapter.position = index + 1;
        tempObj.checklistChapterModels.push(chapter);
      });
      setChecklistObj(tempObj);
    } else {
      var remainingBlocks = tempObj.checklistChapterModels[
        chapterindex
      ].checklistBlockModels.filter((block, index) => {
        return index != blockindex;
      });
      tempObj.checklistChapterModels[chapterindex].checklistBlockModels = [];
      remainingBlocks.map((block, index) => {
        block.position = index + 1;
        tempObj.checklistChapterModels[chapterindex].checklistBlockModels.push(
          block,
        );
      });
      setChecklistObj(tempObj);
    }
  }

  function deleteImages(chapterindex, blockindex, fileindex) {
    var tempObj = { ...checklistObj };
    var remainingImages = tempObj.checklistChapterModels[
      chapterindex
    ].checklistBlockModels[blockindex].files.filter((file, index) => {
      return index != fileindex;
    });
    tempObj.checklistChapterModels[chapterindex].checklistBlockModels[
      blockindex
    ].files = [];
    remainingImages.map((image) => {
      tempObj.checklistChapterModels[chapterindex].checklistBlockModels[
        blockindex
      ].files.push(image);
    });
    setChecklistObj(tempObj);
  }

  function validateCheckList() {
    let chapterData = checklistObj.checklistChapterModels;
    if (chapterData && chapterData.length == 0) {
      toast.error(localization.addOneChapterMsg);
      return false;
    } else if (chapterData.length > 0) {
      //Validate for blank chapter title
      for (var i = 0; i < chapterData.length; i++) {
        if (chapterData[i].title.trim() == "") {
          toast.error(localization.enterTitleToChapter + " " + (i + 1));
          return false;
        } else if (!validateBlocks(i, chapterData[i])) {
          return false;
        }
      }
    }

    return true;
  }

  function validateBlocks(chapterIndex, chapterData) {
    //validate for no blocks added to the chapter
    let blockData = chapterData.checklistBlockModels;
    if (blockData.length == 0) {
      toast.error(localization.addBlockToChapter + " " + (chapterIndex + 1));
      return false;
    } else if (blockData.length > 0) {
      for (var i = 0; i < blockData.length; i++) {
        if (blockData[i].title.trim() == "") {
          toast.error(
            localization.enterTitleToBlock +
              " " +
              (i + 1) +
              " " +
              localization.ofChapter +
              " " +
              (chapterIndex + 1),
          );
          return false;
        } else if (blockData[i].pruefFragenItemModels.length == 0) {
          toast.error(
            localization.addAtleastOneQuestion +
              " " +
              (i + 1) +
              " " +
              localization.ofChapter +
              " " +
              (chapterIndex + 1),
          );
          return false;
        } else if (blockData[i].pruefFragenItemModels.length > 0) {
          let questionsLength = blockData[i].pruefFragenItemModels.length;
          let questionData = blockData[i].pruefFragenItemModels;
          for (var j = 0; j < questionsLength; j++) {
            if (questionData[j].frage.trim() == "") {
              toast.error(
                localization.pleaseEnterQuestion +
                  " " +
                  (j + 1) +
                  " " +
                  localization.toTheBlock +
                  " " +
                  (i + 1) +
                  " " +
                  localization.ofChapter +
                  " " +
                  (chapterIndex + 1),
              );
              return false;
            } else if (
              questionData[j].answerType == "RadioOption" &&
              questionData[j].radioOption.trim() == ""
            ) {
              toast.error(
                localization.enterRadioOptionsForQuestion +
                  " " +
                  (j + 1) +
                  " " +
                  localization.toTheBlock +
                  " " +
                  (i + 1) +
                  " " +
                  localization.ofChapter +
                  " " +
                  (chapterIndex + 1),
              );
              return false;
            } else if (
              questionData[j].answerType == "RadioOption" &&
              questionData[j].radioOption.trim() != "" &&
              questionData[j].radioOption.trim().split(";").length > 5
            ) {
              toast.error(
                localization.maxOptionAllowed +
                  " " +
                  (j + 1) +
                  " " +
                  localization.toTheBlock +
                  " " +
                  (i + 1) +
                  " " +
                  localization.ofChapter +
                  " " +
                  (chapterIndex + 1),
              );
              return false;
            } else if (
              questionData[j].answerType == "RangeValue" &&
              (isNaN(questionData[j].rangeValue["min"]) ||
                isNaN(questionData[j].rangeValue["max"]))
            ) {
              let str =
                isNaN(questionData[j].rangeValue["min"]) &&
                isNaN(questionData[j].rangeValue["max"])
                  ? localization.minAndMax
                  : isNaN(questionData[j].rangeValue["min"])
                    ? localization.minimum
                    : isNaN(questionData[j].rangeValue["max"])
                      ? localization.maximum
                      : "";
              if (str != "") {
                toast.error(
                  localization.pleaseEnter +
                    " " +
                    str +
                    " " +
                    localization.rangeValueForQuestion +
                    " " +
                    (j + 1) +
                    " " +
                    localization.toTheBlock +
                    " " +
                    (i + 1) +
                    " " +
                    localization.ofChapter +
                    " " +
                    (chapterIndex + 1),
                );
                return false;
              }
            } else if (
              questionData[j].answerType == "RangeValue" &&
              questionData[j].rangeValue["min"] != "" &&
              questionData[j].rangeValue["max"] != ""
            ) {
              if (
                parseFloat(questionData[j].rangeValue["min"]) >=
                parseFloat(questionData[j].rangeValue["max"])
              ) {
                toast.error(
                  localization.minValueLessThanMax +
                    " " +
                    (j + 1) +
                    " " +
                    localization.ofTheBlock +
                    " " +
                    (i + 1) +
                    " " +
                    localization.ofChapter +
                    " " +
                    (chapterIndex + 1),
                );
                return false;
              }
            } else if (
              questionData[j].shouldTakeEquipmentOutOfOrder &&
              questionData[j].antwort.trim() == "" &&
              questionData[j].answerType != "RangeValue"
            ) {
              toast.error(
                localization.provideExpectedAns +
                  " " +
                  (j + 1) +
                  " " +
                  localization.ofTheBlock +
                  " " +
                  (i + 1) +
                  " " +
                  localization.ofChapter +
                  " " +
                  (chapterIndex + 1),
              );
              return false;
            }
          }
        }
      }
    }
    return true;
  }

  const RenderQuestions = (props) => {
    const { question, chapterindex, blockindex, questionindex, onSave } = props;
    const [value, setValue] = useState(question.frage);
    const [expectedAnswer, setExpectedAnswer] = useState(question.antwort);
    const [defaultAnswer, setDefaultAnswer] = useState(question.defaultAnswer);
    const [radioOptions, setRadioOptions] = useState(question.radioOption);
    const [rangeMinValue, setRangeMinValue] = useState(
      question.rangeValue ? parseFloat(question.rangeValue["min"]) : "",
    );
    const [rangeMaxValue, setRangeMaxValue] = useState(
      question.rangeValue ? parseFloat(question.rangeValue["max"]) : "",
    );

    const handleInputChange = (e) => {
      setValue(e.target.value);
    };

    const handleRadioOptionsInputChange = (e) => {
      setRadioOptions(e.target.value);
    };

    const handleMinValueInputChange = (e) => {
      setRangeMinValue(e.target.value);
    };

    const handleMaxValueInputChange = (e) => {
      setRangeMaxValue(e.target.value);
    };

    const handleSave = () => {
      onSave(
        "Title",
        chapterindex,
        blockindex,
        questionindex,
        value,
        question.answerType,
      );
    };

    const handleExpectedAnsInputChange = (e) => {
      setExpectedAnswer(e.target.value);
    };

    const handleExpectedAnsSave = () => {
      onSave(
        "ExpectedAnswer",
        chapterindex,
        blockindex,
        questionindex,
        expectedAnswer,
        question.answerType,
      );
    };

    const handleRadioOptionsSave = () => {
      onSave(
        "RadioOption",
        chapterindex,
        blockindex,
        questionindex,
        radioOptions,
        question.answerType,
      );
    };

    const handleRangeMinValueSave = () => {
      onSave(
        "RangeMinValue",
        chapterindex,
        blockindex,
        questionindex,
        rangeMinValue,
        question.answerType,
      );
    };

    const handleRangeMaxValueSave = () => {
      onSave(
        "RangeMaxValue",
        chapterindex,
        blockindex,
        questionindex,
        rangeMaxValue,
        question.answerType,
      );
    };

    switch (question.answerType) {
      case "text":
      case "Yes/No":
      case "Number":
      case "Description":
      case "RadioOption":
      case "RangeValue":
        return (
          <>
            <div className="questionDiv">
              <div className="form-group">
                <label
                  className="form-label requiredCls"
                  htmlFor={"label" + questionindex}
                >
                  {localization.question + " " + (questionindex + 1)}
                </label>
                <input
                  id={"label" + questionindex}
                  name={"label" + questionindex}
                  className="form-control"
                  value={value}
                  placeholder={localization.enterQuestion}
                  onBlur={handleSave}
                  onChange={handleInputChange}
                />
              </div>
              <div>
                {localization.answerType} -{" "}
                {localization[question.answerType]}{" "}
              </div>
              {question.answerType == "RadioOption" && (
                <div className="form-group">
                  <label
                    className="form-label requiredCls"
                    htmlFor={"labelForOptions" + questionindex}
                  >
                    {localization.enterOptions}
                  </label>
                  <input
                    id={"labelForOptions" + questionindex}
                    name={"labelForOptions" + questionindex}
                    className="form-control"
                    value={radioOptions}
                    placeholder={localization.enterOptionsLike}
                    onBlur={handleRadioOptionsSave}
                    onChange={handleRadioOptionsInputChange}
                  />
                </div>
              )}
              {question.answerType == "RangeValue" && (
                <>
                  <div className="form-group">
                    <label
                      className="form-label requiredCls"
                      htmlFor={"labelForRangeMinValue" + questionindex}
                    >
                      {localization.enterMinValue}
                    </label>
                    <input
                      type="Number"
                      id={"labelForRangeMinValue" + questionindex}
                      name={"labelForRangeMinValue" + questionindex}
                      className="form-control"
                      value={rangeMinValue}
                      placeholder={localization.enterMinValue}
                      onBlur={handleRangeMinValueSave}
                      onChange={handleMinValueInputChange}
                    />
                  </div>

                  <div className="form-group">
                    <label
                      className="form-label requiredCls"
                      htmlFor={"labelForRangeMaxValue" + questionindex}
                    >
                      {localization.enterMaxValue}
                    </label>
                    <input
                      type="Number"
                      id={"labelForRangeMaxValue" + questionindex}
                      name={"labelForRangeMaxValue" + questionindex}
                      className="form-control"
                      value={rangeMaxValue}
                      placeholder={localization.enterMaxValue}
                      onBlur={handleRangeMaxValueSave}
                      onChange={handleMaxValueInputChange}
                    />
                  </div>
                </>
              )}

              {shouldTakeEquipmentOutOfOrder && (
                <div className="controlSwitch">
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Switch
                          color="primary"
                          checked={question.shouldTakeEquipmentOutOfOrder}
                          onChange={(e) => {
                            if (e.target.checked && !question.isMandatory) {
                              setConfirmationPopUpOpen(true);
                              setConfirmationPopUpMsg(
                                localization.questionMandatoryMsg,
                              );
                              setCallbackData({
                                isON: e.target.checked,
                                chapterindex: chapterindex,
                                blockindex: blockindex,
                                questionindex: questionindex,
                                answerType: question.answerType,
                              });
                              setEventType("QUESTION_MANDATORY");
                            } else {
                              updateQuestionDetails(
                                "ShouldTakeEquipmentOutOfOrder",
                                chapterindex,
                                blockindex,
                                questionindex,
                                e.target.checked,
                                question.answerType,
                              );
                            }
                          }}
                        />
                      }
                      label={localization.questionCanSetIoNio}
                      labelPlacement="start"
                    />
                  </FormGroup>
                </div>
              )}
              {question.shouldTakeEquipmentOutOfOrder &&
                (question.answerType == "text" ||
                  question.answerType == "Number" ||
                  question.answerType == "Description" ||
                  question.answerType == "RadioOption") && (
                  <div className="form-group">
                    <label
                      className="form-label requiredCls"
                      htmlFor={"expectedAns" + questionindex}
                    >
                      {localization.expectedAnsforQuestion +
                        " " +
                        (questionindex + 1)}
                    </label>
                    <input
                      type={question.answerType == "Number" ? "Number" : "text"}
                      id={"expectedAns" + questionindex}
                      name={"expectedAns" + questionindex}
                      className="form-control"
                      value={expectedAnswer}
                      placeholder={localization.enterExpectedAns}
                      onBlur={handleExpectedAnsSave}
                      onChange={handleExpectedAnsInputChange}
                    />
                  </div>
                )}

              {question.shouldTakeEquipmentOutOfOrder &&
                question.answerType == "Yes/No" && (
                  <div className="form-group w-25">
                    <label className="form-label requiredCls" htmlFor="answer">
                      {localization.selectExpectedAns}
                    </label>
                    <select
                      className="form-control"
                      id="answer"
                      name="antwort"
                      value={expectedAnswer}
                      onChange={(e) => {
                        updateQuestionDetails(
                          "ExpectedAnswer",
                          chapterindex,
                          blockindex,
                          questionindex,
                          e.target.value,
                          question.answerType,
                        );
                      }}
                    >
                      <option value="" disabled>
                        {localization.selectExpectedAns}
                      </option>
                      <option value="J">{localization.yes}</option>
                      <option value="N">{localization.no}</option>
                    </select>
                  </div>
                )}
              {question.answerType == "Yes/No" && (
                <div className="form-group w-25">
                  <label className="form-label" htmlFor="defaultAnswer">
                    {localization.defaultanswer}
                  </label>
                  <select
                    className="form-control"
                    id="defaultAnswer"
                    name="defaultAnswer"
                    value={defaultAnswer}
                    onChange={(e) => {
                      updateQuestionDetails(
                        "DefaultAnswer",
                        chapterindex,
                        blockindex,
                        questionindex,
                        e.target.value,
                        question.answerType,
                      );
                    }}
                  >
                    <option value="">{localization.selectdefaultAnswer}</option>
                    <option value="true">{localization.yes}</option>
                    <option value="false">{localization.no}</option>
                  </select>
                </div>
              )}
            </div>
          </>
        );
    }
  };

  function updateQuestionLevelOutOfOrderFlag(checkListIoNioFlag) {
    let tempObj = { ...checklistObj };
    if (tempObj.checklistChapterModels.length > 0) {
      for (var i = 0; i < tempObj.checklistChapterModels.length; i++) {
        if (tempObj.checklistChapterModels[i].checklistBlockModels.length > 0) {
          var blockLengh =
            tempObj.checklistChapterModels[i].checklistBlockModels.length;
          for (var j = 0; j < blockLengh; j++) {
            if (
              tempObj.checklistChapterModels[i].checklistBlockModels[j]
                .pruefFragenItemModels.length > 0
            ) {
              var questionsLength =
                tempObj.checklistChapterModels[i].checklistBlockModels[j]
                  .pruefFragenItemModels.length;
              for (var k = 0; k < questionsLength; k++) {
                tempObj.checklistChapterModels[i].checklistBlockModels[
                  j
                ].pruefFragenItemModels[k].shouldTakeEquipmentOutOfOrder =
                  checkListIoNioFlag;

                if (!checkListIoNioFlag) {
                  tempObj.checklistChapterModels[i].checklistBlockModels[
                    j
                  ].pruefFragenItemModels[k].antwort = "";
                } else if (
                  tempObj.checklistChapterModels[i].checklistBlockModels[j]
                    .pruefFragenItemModels[k].answerType == "Yes/No" &&
                  tempObj.checklistChapterModels[i].checklistBlockModels[j]
                    .pruefFragenItemModels[k].antwort == ""
                ) {
                  tempObj.checklistChapterModels[i].checklistBlockModels[
                    j
                  ].pruefFragenItemModels[k].antwort = "J";
                }

                if (
                  tempObj.checklistChapterModels[i].isMandatory ||
                  tempObj.checklistChapterModels[i].checklistBlockModels[j]
                    .isMandatory ||
                  checkListIoNioFlag
                ) {
                  tempObj.checklistChapterModels[i].checklistBlockModels[
                    j
                  ].pruefFragenItemModels[k].isMandatory = true;
                } else {
                  tempObj.checklistChapterModels[i].checklistBlockModels[
                    j
                  ].pruefFragenItemModels[k].isMandatory = false;
                }
              }
            }
          }
        }
      }
      setChecklistObj(tempObj);
    }
  }

  const confirmationOkCancelCallback = (isConfirmed, eventType, data) => {
    if (isConfirmed) {
      switch (eventType) {
        case "SAVE":
          pruefPlanAdd(data.event);
          closePopUpCallback();
          break;
        case "CHAPTER_MANDATORY":
          updateChapterDetails("IsMandatory", data.chapterindex, data.isON);
          if (data.isON) {
            forceBlockAndQuestionMandatory(data.chapterindex);
          }
          closePopUpCallback();
          break;
        case "BLOCK_MANDATORY":
          updateBlockDetails(
            "IsMandatory",
            data.chapterindex,
            data.blockindex,
            data.isON,
          );
          if (data.isON) {
            forceQuestionMandatory(data.chapterindex, data.blockindex);
          }
          closePopUpCallback();
          break;
        case "QUESTION_MANDATORY":
          updateQuestionDetails(
            "ShouldTakeEquipmentOutOfOrder",
            data.chapterindex,
            data.blockindex,
            data.questionindex,
            data.isON,
            data.answerType,
          );
          if (data.isON) {
            forceIndividualQuestionMandatory(
              data.chapterindex,
              data.blockindex,
              data.questionindex,
            );
          }
          closePopUpCallback();
          break;
        default:
          break;
      }
    } else {
      closePopUpCallback();
    }
  };

  function forceBlockAndQuestionMandatory(chapterindex) {
    let tempObj = { ...checklistObj };
    tempObj.checklistChapterModels[chapterindex].checklistBlockModels.map(
      (block) => {
        block.isMandatory = true;
        block.pruefFragenItemModels.map((question) => {
          question.isMandatory = true;
        });
      },
    );
    setChecklistObj(tempObj);
  }

  function forceQuestionMandatory(chapterindex, blockindex) {
    let tempObj = { ...checklistObj };
    tempObj.checklistChapterModels[chapterindex].checklistBlockModels[
      blockindex
    ].pruefFragenItemModels.map((question) => {
      question.isMandatory = true;
    });
    setChecklistObj(tempObj);
  }

  function forceIndividualQuestionMandatory(
    chapterindex,
    blockindex,
    questionindex,
  ) {
    let tempObj = { ...checklistObj };
    tempObj.checklistChapterModels[chapterindex].checklistBlockModels[
      blockindex
    ].pruefFragenItemModels[questionindex].isMandatory = true;
    setChecklistObj(tempObj);
  }

  const closePopUpCallback = () => {
    setConfirmationPopUpOpen(false);
    setConfirmationPopUpMsg("");
    setCallbackData(null);
    setEventType(null);
  };

  return (
    <>
      <div
        className={"modal fade  nestedPopover"}
        id="addDigitalChecklist"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="addDigitalChecklist"
        aria-hidden="true"
        data-backdrop="static"
        data-focus="false"
      >
        <div
          className={`custom-modal modal-dialog d-flex justify-content-center ${
            isWizard ? "mt-5" : ""
          }`}
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="addDigitalChecklistTitle">
                {currentPruefPlan
                  ? localization.editChecklist
                  : localization.createNewChecklist}
              </h5>

              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                id="addDigitalChecklistModalClose"
                onClick={closePrufePlanCallback}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <form
              className="formStyle"
              id="addDigitalChecklistForm"
              name="addDigitalChecklistForm"
              onSubmit={pruefPlanAdd}
            >
              <div className="modal-body">
                {!isNextPage ? (
                  <div className="" ref={scrollRef}>
                    <div className="container">
                      <div className="row">
                        <div className="col-5 mr-5 leftSection">
                          <div className="row form-group">
                            <label
                              className="form-label"
                              htmlFor="checklistTitle"
                            >
                              {localization.title}
                            </label>
                            <input
                              type="text"
                              id="checklistTitle"
                              name="checklistTitle"
                              className="form-control"
                              required
                              readOnly={viewModeOnly}
                              placeholder={localization.enterChecklistTitle}
                              value={purefPlanData.checklistTitle}
                              onChange={(e) => {
                                handlePruefPlan(e);
                              }}
                            />
                          </div>
                          <div className="row form-group">
                            <label
                              className="form-label"
                              htmlFor="checklistDesc"
                            >
                              {localization.description}
                            </label>
                            <textarea
                              id="checklistDesc"
                              name="checklistDesc"
                              className="form-control"
                              readOnly={viewModeOnly}
                              required
                              rows={22}
                              placeholder={localization.enterChecklistDesc}
                              value={purefPlanData.checklistDesc}
                              onChange={(e) => {
                                handlePruefPlan(e);
                              }}
                            />
                          </div>
                        </div>

                        <div className="col-6 rightSection">
                          <div className="row form-group">
                            <label
                              htmlFor="equipmentGroupList"
                              className="mr-3"
                            >
                              {localization.equipmentGroup}
                            </label>
                            <select
                              className="form-control"
                              id="equipmentGroupList"
                              name="equipmentGroupList"
                              value={equipmentGroupId}
                              disabled={isWizard}
                              readOnly={viewModeOnly}
                              onChange={(e) => {
                                setEquipmentGroupId(e.target.value);
                              }}
                            >
                              <option value="">
                                {localization.selectEquipmentGroup}
                              </option>
                              {egList.map((row, index) => {
                                return (
                                  <option key={index} value={row.id}>
                                    {row.bezeichnungsDisplay}
                                  </option>
                                );
                              })}
                            </select>
                          </div>
                          <div className="row form-group">
                            <label className="form-label" htmlFor="ChecklistNr">
                              {localization.ChecklistNr}
                            </label>
                            <input
                              type="text"
                              id="ChecklistNr"
                              name="ChecklistNr"
                              className="form-control"
                              required
                              readOnly={viewModeOnly}
                              placeholder={localization.ChecklistNr}
                              value={purefPlanData.ChecklistNr || ""}
                              onChange={(e) => {
                                handlePruefPlan(e);
                              }}
                            />
                          </div>
                          <div className=" row form-group">
                            <label
                              className="form-label"
                              htmlFor="kurzbezeichnung"
                            >
                              {localization.kurzbezeichnung}
                            </label>
                            <input
                              type="text"
                              id="kurzbezeichnung"
                              name="kurzbezeichnung"
                              className="form-control"
                              required
                              readOnly={viewModeOnly}
                              placeholder={localization.kurzbezeichnung}
                              value={purefPlanData.kurzbezeichnung}
                              onChange={(e) => {
                                handlePruefPlan(e);
                              }}
                            />
                          </div>
                          <div className="row form-group">
                            <label htmlFor="kostPruefGroups">
                              {isPruefGroupTestCriteria
                                ? localization.pruefGroup
                                : localization.costCenterGroup}
                            </label>
                            <select
                              className="form-control"
                              id="kostPruefGroupsId"
                              name="kostPruefGroupsId"
                              required={equipmentGroupId}
                              disabled={viewModeOnly}
                              value={purefPlanData.kostPruefGroupsId}
                              onChange={(e) => {
                                handlePruefPlan(e);
                              }}
                            >
                              <option value="">
                                {localization.kostPruefGroupsLIST}
                                {isPruefGroupTestCriteria
                                  ? localization.pruefGroup
                                  : localization.kost}
                              </option>
                              {kostPruefGroupsList.map((row, index) => {
                                return (
                                  <option key={index} value={row.id}>
                                    {row.name}
                                  </option>
                                );
                              })}
                            </select>
                          </div>
                          <div className="row form-group ">
                            <label
                              className="form-label"
                              htmlFor="fixedSchedule"
                            >
                              {localization.fixedSchedule}
                            </label>
                            <select
                              className="form-control"
                              id="fixedSchedule"
                              name="fixedSchedule"
                              disabled={viewModeOnly}
                              value={scheduleObj.fixedSchedule}
                              onChange={(e) => {
                                handlePruefPlanScheduleBoolen(e);
                              }}
                            >
                              <option value={true}>{localization.yes}</option>
                              <option value={false}>{localization.no}</option>
                            </select>
                          </div>
                          <div className="row form-group">
                            <label
                              className="form-label"
                              htmlFor="generateInspection"
                            >
                              {localization.generateInspection}
                            </label>
                            <select
                              className="form-control"
                              id="generateInspection"
                              name="generateInspection"
                              required
                              disabled={viewModeOnly}
                              value={scheduleObj.generateInspection}
                              onChange={(e) => {
                                handlePruefPlanScheduleBoolen(e);
                              }}
                            >
                              <option value={true}>
                                {`${localization.yes} (${localization.itgenerateallinspectioninculdingskip})`}
                              </option>
                              <option value={false}>
                                {`${localization.no} (${localization.itgenerateonlythoseinspectionwhicharedone})`}
                              </option>
                            </select>
                          </div>
                          <div className="row form-group">
                            <label
                              className="form-label"
                              htmlFor="deleteInspection"
                            >
                              {localization.deleteInspection} (
                              {localization.never})
                            </label>
                            <input
                              className="form-control"
                              id="deleteInspection"
                              type="number"
                              name="deleteInspection"
                              min={0}
                              disabled={viewModeOnly}
                              placeholder={localization.noOfDays}
                              value={scheduleObj.deleteInspection}
                              onChange={(e) => {
                                handlePruefPlanSchedule(e);
                              }}
                            />
                          </div>
                          <div className="row form-group ">
                            <label
                              className="form-label"
                              htmlFor="deleteInspectionPhoto"
                            >
                              {localization.deleteInspectionPhoto} (
                              {localization.never})
                            </label>
                            <input
                              className="form-control"
                              type="number"
                              id="deleteInspectionPhoto"
                              name="deleteInspectionPhoto"
                              min={0}
                              placeholder={localization.noOfDays}
                              disabled={deleteFlag || viewModeOnly}
                              value={scheduleObj.deleteInspectionPhoto}
                              onChange={(e) => {
                                handlePruefPlanSchedule(e);
                              }}
                            />
                          </div>
                          <div className="row form-group ">
                            <label
                              className="form-label"
                              htmlFor="isImageRequired"
                            >
                              {localization.isImageRequired}
                            </label>
                            <select
                              className="form-control"
                              id="isImageRequired"
                              name="isImageRequired"
                              disabled={viewModeOnly}
                              value={isImageRequired}
                              onChange={(e) => {
                                setIsImageRequired(e.target.value);
                              }}
                            >
                              <option value="No">{localization.no}</option>
                              <option value="OnlyNIO">
                                {localization.onlyNIO}
                              </option>
                              <option value="BothIOAndNIO">
                                {localization.bothIOandNIO}
                              </option>
                            </select>
                          </div>
                          <div className="row flex-column form-group">
                            <div className="row ml-0">
                              <label className="form-label" htmlFor="frequenz">
                                {localization.frequencyInfo}
                              </label>
                            </div>
                            <div className="row">
                              <div className="col-5 pr-0">
                                <input
                                  type="number"
                                  id="turnusanzahl"
                                  name="turnusanzahl"
                                  className="form-control"
                                  min={1}
                                  disabled={
                                    purefPlanData.turnuszyklus == "A" ||
                                    equipmentGroupId == ""
                                  }
                                  required={purefPlanData.turnuszyklus != "A"}
                                  readOnly={viewModeOnly}
                                  value={
                                    purefPlanData.turnuszyklus == "A" ||
                                    equipmentGroupId == ""
                                      ? 0
                                      : purefPlanData.turnusanzahl
                                  }
                                  onKeyPress={(e) => {
                                    // Allow only numeric keys (0-9)
                                    let isValidInput;
                                    if (purefPlanData.turnusanzahl === "") {
                                      isValidInput = /^[1-9\b]+$/.test(e.key);
                                    } else {
                                      isValidInput = /^[0-9\b]+$/.test(e.key);
                                    }
                                    if (!isValidInput) {
                                      e.preventDefault();
                                    }
                                  }}
                                  onChange={(e) => {
                                    handlePruefPlan(e);
                                  }}
                                />
                              </div>
                              <div className="col-7 pl-1">
                                <select
                                  className="form-control"
                                  id="turnuszyklus"
                                  name="turnuszyklus"
                                  required
                                  disabled={
                                    viewModeOnly || equipmentGroupId == ""
                                  }
                                  value={
                                    equipmentGroupId == ""
                                      ? "A"
                                      : purefPlanData.turnuszyklus
                                  }
                                  onChange={(e) => {
                                    handlePruefPlan(e);
                                  }}
                                >
                                  <option value="" disabled>
                                    {localization.select}
                                  </option>
                                  <option value="Y">{localization.year}</option>
                                  <option value="M">
                                    {localization.month}
                                  </option>
                                  <option value="D">{localization.day}</option>
                                  <option value="A">
                                    {localization.anytime}
                                  </option>
                                </select>
                              </div>
                            </div>
                            {purefPlanData.turnuszyklus != "" &&
                              purefPlanData.turnuszyklus != "A" &&
                              purefPlanData.turnusanzahl > 0 && (
                                <label
                                  className="form-label"
                                  htmlFor="turnusanzahl"
                                >
                                  {`${localization.every} ${
                                    purefPlanData.turnusanzahl
                                  }  ${
                                    purefPlanData.turnuszyklus === "M"
                                      ? localization.month
                                      : purefPlanData.turnuszyklus === "Y"
                                        ? localization.year
                                        : localization.day
                                  }`}
                                </label>
                              )}
                          </div>
                          {scheduleObj.fixedSchedule && (
                            <div className="row form-group">
                              <label
                                className="form-label"
                                htmlFor="toleranceCheck "
                              >
                                {localization.toleranceCheck}
                              </label>
                              <input
                                type="number"
                                id="toleranceCheck"
                                name="toleranceCheck"
                                className={`form-control  ${
                                  scheduleObj.toleranceCheck > 100
                                    ? "is-invalid"
                                    : ""
                                }`}
                                required
                                min={0}
                                readOnly={viewModeOnly}
                                value={scheduleObj.toleranceCheck}
                                onKeyPress={(e) => {
                                  // Allow only numeric keys (0-9)
                                  let isValidInput = /^[0-9\b]+$/.test(e.key);

                                  if (!isValidInput) {
                                    e.preventDefault();
                                  }
                                }}
                                onChange={(e) => {
                                  handlePruefPlanSchedule(e);
                                }}
                              />{" "}
                              {scheduleObj.toleranceCheck > 100 && (
                                <div className="invalid-feedback">
                                  {localization.errorMsgTolrance}
                                </div>
                              )}
                            </div>
                          )}
                          {scheduleObj.fixedSchedule && (
                            <div className="row flex-column form-group mt-2">
                              <label className="form-label">
                                {localization.IsnumberOfSchedules}
                              </label>
                              <div className="row">
                                <div className="col-4">
                                  <div className="row">
                                    <div className="col-2">
                                      <input
                                        type="radio"
                                        name="numberOfSchedules"
                                        value="Single"
                                        checked={numberOfSchedules === "Single"}
                                        disabled={
                                          purefPlanData.turnuszyklus != "D" ||
                                          !scheduleObj.fixedSchedule ||
                                          viewModeOnly
                                        }
                                        onChange={(e) => {
                                          setNumberOfSchedules("Single");
                                        }}
                                      />
                                    </div>
                                    <div className="col p-0">
                                      {localization.single}
                                    </div>
                                  </div>
                                </div>
                                <div className="col-4">
                                  <div className="row">
                                    <div className="col-2">
                                      <input
                                        type="radio"
                                        name="numberOfSchedules"
                                        value="Multiple"
                                        disabled={
                                          purefPlanData.turnuszyklus != "D" ||
                                          viewModeOnly
                                        }
                                        checked={
                                          numberOfSchedules === "Multiple"
                                        }
                                        onChange={(e) => {
                                          setNumberOfSchedules("Multiple");
                                        }}
                                      />
                                    </div>
                                    <div className="col p-0">
                                      {localization.multiple}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                          {numberOfSchedules === "Multiple" &&
                            scheduleObj.fixedSchedule && (
                              <div className="row form-group ">
                                <label
                                  className="form-label"
                                  htmlFor="frequencySchedules"
                                >
                                  {localization.selectTheNumberOfSchedulePerday}
                                </label>
                                <select
                                  className="form-control"
                                  id="frequencySchedules"
                                  name="frequencySchedules"
                                  required
                                  disabled={viewModeOnly}
                                  value={frequencySchedules}
                                  onChange={(e) => {
                                    setFrequencySchedules(e.target.value);
                                  }}
                                >
                                  <option value="" disabled>
                                    {localization.select}
                                  </option>
                                  <option value="2">2 </option>
                                  <option value="3">3 </option>
                                  <option value="4">4 </option>
                                  <option value="5">5 </option>
                                </select>
                              </div>
                            )}
                          {purefPlanData.turnuszyklus === "D" &&
                            numberOfSchedules === "Single" &&
                            scheduleObj.fixedSchedule && (
                              <div className="row flex-column form-group mt-2">
                                <div className="row ml-0">
                                  <label className="form-label">
                                    {localization.startTimeSchedule}
                                  </label>
                                </div>
                                <div className="row ml-0">
                                  <div className="col-4 colpadding">
                                    <label
                                      className="form-label"
                                      htmlFor="time"
                                    >
                                      {localization.time}
                                    </label>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-3 ">
                                    <select
                                      className="form-control"
                                      id="time"
                                      name="time"
                                      required
                                      disabled={viewModeOnly}
                                      value={yearlySchedule.time}
                                      onChange={(e) => {
                                        handleInspectionSchedule(e);
                                      }}
                                    >
                                      <option value="" disabled>
                                        {localization.select}
                                      </option>
                                      {timeSelectRender}
                                    </select>
                                  </div>
                                </div>
                              </div>
                            )}
                          {frequencySchedules &&
                            numberOfSchedules === "Multiple" &&
                            scheduleObj.fixedSchedule &&
                            renderDaysSchedules}
                          {purefPlanData.turnuszyklus === "D" && (
                            <div className="row form-group mt-2">
                              <label
                                className="form-label"
                                htmlFor="excludeDay"
                              >
                                {localization.excludeDay}
                              </label>

                              <div className="container ">
                                <CheckBox
                                  daysCheck={daysCheck}
                                  handlecheckBox={handlecheckBox}
                                  viewModeOnly={viewModeOnly}
                                />
                              </div>
                            </div>
                          )}

                          {purefPlanData.turnuszyklus === "Y" &&
                            scheduleObj.fixedSchedule && (
                              <div className="row flex-column form-group  ">
                                <div className="row ml-0">
                                  <label className="form-label" htmlFor="Year">
                                    {localization.startTimeSchedule}
                                  </label>
                                </div>
                                <div className="row ml-0">
                                  <div className="col-3">
                                    <label
                                      className="form-label"
                                      htmlFor="year"
                                    >
                                      {localization.year}
                                    </label>
                                  </div>
                                  <div className="col-3">
                                    <label
                                      className="form-label"
                                      htmlFor="month"
                                    >
                                      {localization.month}
                                    </label>
                                  </div>
                                  <div className="col-3">
                                    <label className="form-label" htmlFor="day">
                                      {localization.day}
                                    </label>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-3">
                                    <select
                                      className="form-control"
                                      id="year"
                                      name="year"
                                      required
                                      disabled={viewModeOnly}
                                      value={yearlySchedule.year}
                                      onChange={(e) => {
                                        handleInspectionSchedule(e);
                                      }}
                                    >
                                      <option value="" disabled>
                                        {localization.select}
                                      </option>
                                      {yearSelectRender}
                                    </select>
                                  </div>
                                  <div className="col-3 pr-0">
                                    <select
                                      className="form-control"
                                      id="month"
                                      name="month"
                                      required
                                      disabled={viewModeOnly}
                                      value={yearlySchedule.month}
                                      onChange={(e) => {
                                        handleInspectionSchedule(e);
                                      }}
                                    >
                                      <option value="" disabled>
                                        {localization.select}
                                      </option>
                                      {monthSelectRender}
                                    </select>
                                  </div>
                                  <div className="col-3 pr-0">
                                    <select
                                      className="form-control"
                                      id="day"
                                      name="day"
                                      required
                                      disabled={
                                        yearlySchedule.month === "" ||
                                        yearlySchedule.year === "" ||
                                        viewModeOnly
                                      }
                                      value={yearlySchedule.day}
                                      onChange={(e) => {
                                        handleInspectionSchedule(e);
                                      }}
                                    >
                                      <option value="" disabled>
                                        {localization.select}
                                      </option>
                                      {daySelectRender}
                                    </select>
                                  </div>
                                </div>
                              </div>
                            )}
                          {purefPlanData.turnuszyklus === "M" &&
                            scheduleObj.fixedSchedule && (
                              <div className="row form-group d-flex flex-column mt-2">
                                <div className="row ml-0">
                                  <label className="form-label">
                                    {localization.startTimeSchedule}
                                  </label>
                                </div>
                                <div className="row ml-0">
                                  <div className="col-3">
                                    <label
                                      className="form-label"
                                      htmlFor="Year"
                                    >
                                      {localization.year}
                                    </label>
                                  </div>
                                  <div className="col-3">
                                    <label
                                      className="form-label"
                                      htmlFor="month"
                                    >
                                      {localization.month}
                                    </label>
                                  </div>
                                  <div className="col-3">
                                    <label className="form-label" htmlFor="day">
                                      {localization.day}
                                    </label>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-3">
                                    <select
                                      className="form-control"
                                      id="year"
                                      name="year"
                                      required
                                      disabled={viewModeOnly}
                                      value={yearlySchedule.year}
                                      onChange={(e) => {
                                        handleInspectionSchedule(e);
                                      }}
                                    >
                                      <option value="" disabled>
                                        {localization.select}
                                      </option>
                                      {yearSelectRender}
                                    </select>
                                  </div>
                                  <div className="col-3 pr-0">
                                    <select
                                      className="form-control"
                                      id="month"
                                      name="month"
                                      required
                                      disabled={viewModeOnly}
                                      value={yearlySchedule.month}
                                      onChange={(e) => {
                                        handleInspectionSchedule(e);
                                      }}
                                    >
                                      <option value="" disabled>
                                        {localization.select}
                                      </option>
                                      {monthSelectRender}
                                    </select>
                                  </div>
                                  <div className="col-3 pr-0">
                                    <select
                                      className="form-control"
                                      id="day"
                                      name="day"
                                      required
                                      disabled={viewModeOnly}
                                      value={yearlySchedule.day}
                                      onChange={(e) => {
                                        handleInspectionSchedule(e);
                                      }}
                                    >
                                      <option value="" disabled>
                                        {localization.select}
                                      </option>
                                      {daySelectRender}
                                    </select>
                                  </div>
                                </div>
                              </div>
                            )}
                          <div className="row form-group">
                            <div className="controlSwitch">
                              <FormGroup>
                                <FormControlLabel
                                  control={
                                    <Switch
                                      color="primary"
                                      checked={shouldTakeEquipmentOutOfOrder}
                                      disabled={viewModeOnly}
                                      onChange={(e) => {
                                        setShouldTakeEquipmentOutOfOrder(
                                          e.target.checked,
                                        );
                                        updateQuestionLevelOutOfOrderFlag(
                                          e.target.checked,
                                        );
                                      }}
                                    />
                                  }
                                  label={localization.chapterCanSetIoNio}
                                  labelPlacement="start"
                                />
                              </FormGroup>
                            </div>
                          </div>
                          <div className="row form-group ">
                            <label
                              className="form-label"
                              htmlFor="isChecklistFeedbackMandatory"
                            >
                              {localization.isChecklistFeedbackMandatory}
                            </label>
                            <select
                              className="form-control"
                              id="isChecklistFeedbackMandatory"
                              name="isChecklistFeedbackMandatory"
                              disabled={viewModeOnly}
                              value={isChecklistFeedbackMandatory}
                              onChange={(e) => {
                                setIsChecklistFeedbackMandatory(e.target.value);
                              }}
                            >
                              <option value="No">{localization.no}</option>
                              <option value="OnlyNIO">
                                {localization.onlyNIO}
                              </option>
                              <option value="BothIOAndNIO">
                                {localization.bothIOandNIO}
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <>
                    <div className="mainChapterContainer">
                      {checklistObj.checklistChapterModels?.map(
                        (chapter, chapterIndex) => {
                          return (
                            <Accordion key={chapterIndex}>
                              <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls={`panel${
                                  chapterIndex + 1
                                }a-content`}
                                id={`panel${chapterIndex + 1}a-header`}
                              >
                                <h4>
                                  {localization.chapter} {`${chapterIndex + 1}`}
                                </h4>
                              </AccordionSummary>
                              <AccordionDetails>
                                <div className="chapterContainer">
                                  <InlineEditableInput
                                    name={"chapterTitle"}
                                    type={"text"}
                                    placeholder={localization.enterChapterTitle}
                                    keyName={"Title"}
                                    objToUpdate={"Chapter"}
                                    chapterindex={chapterIndex}
                                    blockindex={""}
                                    questionindex={""}
                                    initialValue={chapter.title}
                                    onSave={updateChapterDetails}
                                  />
                                  <div className="form-group">
                                    <div className="controlSwitch">
                                      <FormGroup>
                                        <FormControlLabel
                                          control={
                                            <Switch
                                              color="primary"
                                              checked={chapter.isMandatory}
                                              onChange={(e) => {
                                                if (e.target.checked) {
                                                  setConfirmationPopUpOpen(
                                                    true,
                                                  );
                                                  setConfirmationPopUpMsg(
                                                    localization.chapterMandatoryMsg,
                                                  );
                                                  setCallbackData({
                                                    isON: e.target.checked,
                                                    chapterindex: chapterIndex,
                                                  });
                                                  setEventType(
                                                    "CHAPTER_MANDATORY",
                                                  );
                                                } else {
                                                  updateChapterDetails(
                                                    "IsMandatory",
                                                    chapterIndex,
                                                    e.target.checked,
                                                  );
                                                }
                                              }}
                                            />
                                          }
                                          label={localization.isMandatory}
                                          labelPlacement="start"
                                        />
                                      </FormGroup>
                                    </div>
                                  </div>

                                  {chapter.checklistBlockModels?.map(
                                    (block, blockIndex) => {
                                      return (
                                        <div
                                          key={`block-${chapterIndex}-${blockIndex}`}
                                        >
                                          <h3>
                                            {localization.block}{" "}
                                            {`${blockIndex + 1}`}
                                          </h3>
                                          <div className="blockContainer">
                                            <div>
                                              <div className="form-group">
                                                <InlineEditableInput
                                                  name={
                                                    "blockTitle" + blockIndex
                                                  }
                                                  type={"text"}
                                                  placeholder={
                                                    localization.enterBlockTitle
                                                  }
                                                  keyName={"Title"}
                                                  objToUpdate={"Block"}
                                                  chapterindex={chapterIndex}
                                                  blockindex={blockIndex}
                                                  questionindex={""}
                                                  initialValue={block.title}
                                                  onSave={updateBlockDetails}
                                                />
                                              </div>
                                              <div className="form-group">
                                                <InlineEditableInput
                                                  name={
                                                    "blockDescription" +
                                                    blockIndex
                                                  }
                                                  type={"Description"}
                                                  placeholder={
                                                    localization.enterBlockDesc
                                                  }
                                                  keyName={"Description"}
                                                  objToUpdate={"Block"}
                                                  chapterindex={chapterIndex}
                                                  blockindex={blockIndex}
                                                  questionindex={""}
                                                  initialValue={
                                                    block.description
                                                  }
                                                  onSave={updateBlockDetails}
                                                />
                                              </div>
                                              <div className="form-group">
                                                <div className="controlSwitch">
                                                  <FormGroup>
                                                    <FormControlLabel
                                                      control={
                                                        <Switch
                                                          color="primary"
                                                          disabled={
                                                            chapter.isMandatory
                                                          }
                                                          checked={
                                                            block.isMandatory
                                                          }
                                                          onChange={(e) => {
                                                            if (
                                                              e.target.checked
                                                            ) {
                                                              setConfirmationPopUpOpen(
                                                                true,
                                                              );
                                                              setConfirmationPopUpMsg(
                                                                localization.blockMandatoryMsg,
                                                              );
                                                              setCallbackData({
                                                                isON: e.target
                                                                  .checked,
                                                                chapterindex:
                                                                  chapterIndex,
                                                                blockindex:
                                                                  blockIndex,
                                                              });
                                                              setEventType(
                                                                "BLOCK_MANDATORY",
                                                              );
                                                            } else {
                                                              updateBlockDetails(
                                                                "IsMandatory",
                                                                chapterIndex,
                                                                blockIndex,
                                                                e.target
                                                                  .checked,
                                                              );
                                                            }
                                                          }}
                                                        />
                                                      }
                                                      label={
                                                        localization.isMandatory
                                                      }
                                                      labelPlacement="start"
                                                    />
                                                  </FormGroup>
                                                </div>
                                              </div>
                                              <div className="form-group">
                                                <div className="controlSwitch">
                                                  <FormGroup>
                                                    <FormControlLabel
                                                      control={
                                                        <Switch
                                                          color="primary"
                                                          checked={
                                                            block.addMedia
                                                          }
                                                          onChange={(e) => {
                                                            addMedia(
                                                              e,
                                                              chapterIndex,
                                                              blockIndex,
                                                            );
                                                          }}
                                                        />
                                                      }
                                                      label={
                                                        localization.addMedia
                                                      }
                                                      labelPlacement="start"
                                                    />
                                                  </FormGroup>
                                                </div>
                                              </div>

                                              <div className="imageContainer d-flex">
                                                {block.files.map(
                                                  (file, fileIndex) => {
                                                    return (
                                                      <div
                                                        key={fileIndex}
                                                        id={`image${fileIndex}`}
                                                        className="imageContent"
                                                      >
                                                        <img
                                                          src={
                                                            file.filecontent.startsWith(
                                                              "data:",
                                                            )
                                                              ? file.filecontent
                                                              : `data:image/jpg;base64,${file.filecontent}`
                                                          }
                                                          alt=""
                                                        />
                                                        <IoMdCloseCircle
                                                          className="imgCloseCls"
                                                          onClick={(e) => {
                                                            deleteImages(
                                                              chapterIndex,
                                                              blockIndex,
                                                              fileIndex,
                                                            );
                                                          }}
                                                        />
                                                      </div>
                                                    );
                                                  },
                                                )}
                                              </div>

                                              {block.addMedia && (
                                                <div className="form-group customAddMediaInput">
                                                  <div className="d-flex justify-content-center">
                                                    <span>
                                                      {
                                                        localization.clickHereToUpload
                                                      }
                                                    </span>
                                                  </div>
                                                  <div className="d-flex justify-content-center">
                                                    <FiPlus />
                                                  </div>
                                                  <input
                                                    type="file"
                                                    id={`addMedia${chapterIndex}${blockIndex}`}
                                                    name={`addMedia${chapterIndex}${blockIndex}`}
                                                    multiple
                                                    accept="image/*"
                                                    capture="environment"
                                                    onChange={(e) => {
                                                      handleOnchange(
                                                        e,
                                                        chapterIndex,
                                                        blockIndex,
                                                      );
                                                    }}
                                                  />
                                                </div>
                                              )}
                                            </div>
                                            {block.pruefFragenItemModels.map(
                                              (question, questionIndex) => {
                                                return (
                                                  <div
                                                    key={`question-${chapterIndex}-${blockIndex}-${questionIndex}`}
                                                  >
                                                    <div className="blockQuestionContainer">
                                                      <div className="questionBlock">
                                                        <h2>
                                                          {
                                                            localization[
                                                              question
                                                                .answerType
                                                            ]
                                                          }
                                                        </h2>
                                                        <MdDeleteOutline
                                                          title={
                                                            localization.deleteQuestion
                                                          }
                                                          size={20}
                                                          style={{
                                                            cursor: "pointer",
                                                          }}
                                                          onClick={(e) => {
                                                            deleteQuestion(
                                                              chapterIndex,
                                                              blockIndex,
                                                              questionIndex,
                                                            );
                                                          }}
                                                        />
                                                      </div>
                                                      <RenderQuestions
                                                        question={question}
                                                        chapterindex={
                                                          chapterIndex
                                                        }
                                                        blockindex={blockIndex}
                                                        questionindex={
                                                          questionIndex
                                                        }
                                                        onSave={
                                                          updateQuestionDetails
                                                        }
                                                      />
                                                      <div className="controlSwitch">
                                                        <FormGroup>
                                                          <FormControlLabel
                                                            control={
                                                              <Switch
                                                                color="primary"
                                                                disabled={
                                                                  block.isMandatory ||
                                                                  question.shouldTakeEquipmentOutOfOrder
                                                                }
                                                                checked={
                                                                  question.isMandatory
                                                                }
                                                                onChange={(
                                                                  e,
                                                                ) => {
                                                                  updateQuestionDetails(
                                                                    "IsMandatory",
                                                                    chapterIndex,
                                                                    blockIndex,
                                                                    questionIndex,
                                                                    e.target
                                                                      .checked,
                                                                    question.answerType,
                                                                  );
                                                                }}
                                                              />
                                                            }
                                                            label={
                                                              localization.isMandatory
                                                            }
                                                            labelPlacement="start"
                                                          />
                                                        </FormGroup>
                                                      </div>

                                                      <div className="controlSwitch">
                                                        <FormGroup>
                                                          <FormControlLabel
                                                            control={
                                                              <Switch
                                                                color="primary"
                                                                checked={
                                                                  question.canCreateTicket
                                                                }
                                                                onChange={(
                                                                  e,
                                                                ) => {
                                                                  updateQuestionDetails(
                                                                    "CanCreateTicket",
                                                                    chapterIndex,
                                                                    blockIndex,
                                                                    questionIndex,
                                                                    e.target
                                                                      .checked,
                                                                    question.answerType,
                                                                  );
                                                                }}
                                                              />
                                                            }
                                                            label={
                                                              localization.canThisQuestionCreateTicket
                                                            }
                                                            labelPlacement="start"
                                                          />
                                                        </FormGroup>
                                                      </div>
                                                    </div>
                                                  </div>
                                                );
                                              },
                                            )}
                                            <div
                                              className="addQuestionDiv"
                                              onClick={() => {
                                                setOpen(true);
                                                setCurrentBlockIndex(
                                                  blockIndex,
                                                );
                                                setCurrentChapterIndex(
                                                  chapterIndex,
                                                );
                                              }}
                                            >
                                              <div className="d-flex justify-content-center">
                                                <span>
                                                  {
                                                    localization.addQuestionBlocks
                                                  }
                                                </span>
                                              </div>
                                              <div className="d-flex justify-content-center">
                                                <FiPlus />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      );
                                    },
                                  )}

                                  <div className="d-flex justify-content-center">
                                    <button
                                      type="button"
                                      className="btn btn-primary checklistBtnCls mb-4"
                                      onClick={() => {
                                        addNewBlock(chapterIndex);
                                      }}
                                    >
                                      {localization.addNewBlock}
                                    </button>
                                  </div>
                                </div>
                              </AccordionDetails>
                            </Accordion>
                          );
                        },
                      )}

                      <div className="">
                        <div className="d-flex justify-content-center">
                          <button
                            type="button"
                            className="btn btn-primary checklistBtnCls mb-4 mt-4"
                            onClick={() => {
                              addNewChapter();
                            }}
                          >
                            {localization.addNewChapter}
                          </button>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>

              <div className="modal-footer">
                {isNextPage && (
                  <>
                    <div className="form-group marProp">
                      <button
                        type="button"
                        className="btn btn-primary btn-block mb-4"
                        onClick={(e) => {
                          setIsNextPage(false);
                        }}
                      >
                        {localization.back}
                      </button>
                    </div>
                    <div className="form-group marProp">
                      <button
                        type="button"
                        className="btn btn-primary checklistBtnCls mb-4"
                        disabled={viewModeOnly}
                        onClick={(e) => {
                          if (validateCheckList()) {
                            setConfirmationPopUpOpen(true);
                            setConfirmationPopUpMsg(
                              localization.deleteDraftWarningMsg,
                            );
                            setCallbackData({ event: e });
                            setEventType("SAVE");
                            setIsPublish(false);
                          }
                        }}
                      >
                        {localization.saveAsChanges}
                      </button>
                    </div>
                    <div className="form-group marProp">
                      <button
                        type="button"
                        className="btn btn-primary publishChecklistBtnCls mb-4"
                        disabled={viewModeOnly}
                        onClick={(e) => {
                          if (validateCheckList()) {
                            setConfirmationPopUpOpen(true);
                            setConfirmationPopUpMsg(
                              localization.publishChecklistWarningMsg,
                            );
                            setCallbackData({ event: e });
                            setEventType("SAVE");
                            setIsPublish(true);
                          }
                        }}
                      >
                        {localization.saveAndPublish}
                      </button>
                    </div>
                    {(commonUtils.isUserOrganisationAdmin() ||
                      commonUtils.isUserWerkAdmin()) && (
                      <div className="form-group marProp">
                        <button
                          type="button"
                          className="btn btn-primary publishChecklistBtnCls mb-4"
                          disabled={viewModeOnly}
                          onClick={handleSaveAsTemplate}
                        >
                          {localization.saveAsTemplate}
                        </button>
                      </div>
                    )}
                  </>
                )}

                {!isNextPage && (
                  <div className="form-group marProp">
                    <button
                      type="submit"
                      disabled={
                        scheduleObj.toleranceCheck > 100 ||
                        (numberOfSchedules === "Single"
                          ? false
                          : buttonDisableFlag)
                      }
                      className="btn btn-primary btn-block mb-4"
                    >
                      {localization.next}
                    </button>
                  </div>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
      <AddBlockQuestions
        open={open}
        handleClose={handleClose}
        addTemplate={addTemplate}
      />
      <ConfirmationPopUp
        isOpen={confirmationPopUpOpen}
        okCancelCallback={confirmationOkCancelCallback}
        close={closePopUpCallback}
        title=""
        msg={confirmationPopUpMsg}
        eventType={eventType}
        callbackData={callbackData}
      />
    </>
  );
};

export default CreateDigitalChecklist;
